<div class="registration-container">
  <ng-container *transloco="let t;">
    <h1>{{t('auth.registration_form.title')}}</h1>

    <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" aria-label="Registration Form">
      @if (isLoading()) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }

      <mat-form-field appearance="outline">
        <mat-label id="register-email-label">{{t('auth.registration_form.email_label')}}</mat-label>
        <input id="register-email" matInput type="email" formControlName="email" [placeholder]="t('auth.registration_form.email_placeholder')" aria-labelledby="register-email-label">
        @if (registerForm.get('email')?.errors?.['required']) {
          <mat-error>{{t('auth.registration_form.email_err_required')}}</mat-error>
        }
        @if (registerForm.get('email')?.errors?.['email']) {
          <mat-error>{{t('auth.registration_form.email_err_invalid')}}</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label id="register-password-label">{{t('auth.registration_form.password_label')}}</mat-label>
        <input id="password" matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" [placeholder]="t('auth.registration_form.password_placeholder')" aria-labelledby="register-password-label">
        <button mat-icon-button type="button" matSuffix (click)="hidePassword = !hidePassword">
          <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        @if (registerForm.get('password')?.errors?.['required']) {
          <mat-error>{{t('auth.registration_form.password_err_required')}}</mat-error>
        }
        @if (registerForm.get('password')?.errors?.['minlength']) {
          <mat-error>{{t('auth.registration_form.password_err_min_length')}}</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label id="register-confirm-password-label">{{t('auth.registration_form.password_confirm_label')}}</mat-label>
        <input id="confirmPassword" matInput [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="confirmPassword" [placeholder]="t('auth.registration_form.password_confirm_placeholder')" aria-labelledby="register-confirm-password-label">
        <button mat-icon-button type="button" matSuffix (click)="hideConfirmPassword = !hideConfirmPassword">
          <mat-icon>{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        @if (registerForm.errors?.['passwordMismatch']) {
          <mat-error>{{t('auth.registration_form.password_confirm_err_mismatch')}}</mat-error>
        }
      </mat-form-field>

      <div class="form-actions">
        <button mat-raised-button color="primary" type="submit" [disabled]="registerForm.invalid || isLoading()">{{t('auth.registration_form.create_button')}}</button>
        <button mat-button type="button" routerLink="/auth/login" [disabled]="isLoading()">{{t('auth.registration_form.sign_in_button')}}</button>
      </div>

      @if (errorMessage() !== '') {
        <mat-error class="server-error">{{ errorMessage() }}</mat-error>
      }
    </form>
  </ng-container>
</div>
